import { render } from "./ViewerView.vue?vue&type=template&id=510985f8&scoped=true"
import script from "./ViewerView.vue?vue&type=script&lang=js"
export * from "./ViewerView.vue?vue&type=script&lang=js"

import "./ViewerView.vue?vue&type=style&index=0&id=510985f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510985f8"]])

export default __exports__